const actions = {
  setAssinaturaCadastrarCartao({ commit }, payload) {
    commit('SET_ASSINATURA_CADASTRAR_CARTAO', payload);
  },
};

const mutations = {
  /* eslint-disable no-param-reassign */
  SET_ASSINATURA_CADASTRAR_CARTAO(state, payload) {
    state.assinaturaCadastrarCartao = payload;
  },
  /* eslint-enable no-param-reassign */
};

const state = {
  assinaturaCadastrarCartao: false,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
